export default "__VITE_ASSET__DP1cMV7k__"